export enum DeviceSecurityPolicy {
  NONE = "NONE",
  BASIC128_RSA15 = "BASIC128_RSA15",
  BASIC256 = "BASIC256",
  BASIC256_SHA256 = "BASIC256_SHA256",
}

export const deviceSecurityPolicies = Object.values(DeviceSecurityPolicy);
